export interface ChatGptOauthDebug {
  configured: boolean
  prepared: boolean
  injectionMode: "none" | "bootstrap_secret+env_fallback"
  accountId: string | null
  error: string | null
  updatedAt: number
}

export function normalizeChatGptOauthDebug(
  raw: unknown,
): ChatGptOauthDebug | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return null
  }

  const row = raw as Record<string, unknown>
  const rawInjectionMode =
    typeof row.injectionMode === "string"
      ? row.injectionMode
      : null

  return {
    configured: row.configured === true,
    prepared: row.prepared === true,
    injectionMode:
      rawInjectionMode === "bootstrap_secret+env_fallback" ||
        rawInjectionMode === "modal_secret+env_fallback"
        ? "bootstrap_secret+env_fallback"
        : "none",
    accountId: typeof row.accountId === "string" ? row.accountId : null,
    error: typeof row.error === "string" ? row.error : null,
    updatedAt: typeof row.updatedAt === "number" ? row.updatedAt : 0,
  }
}
